import { TRoute, USER_ROLE } from "@/shared/types/route.ts";
import LocationDetail from "@/locations/pages/location-detail.tsx";
import Locations from "@/locations/pages/locations.tsx";
import MachinesDetail from "@/machines/pages/machines-detail/machines-detail.tsx";
import MachinesLive from "@/machines/pages/machines-live/machines-live.tsx";
import MachineSettings from "@/machines/pages/machine-settings/machine-settings.tsx";
import PolygonsPage from "@/polygon/pages/polygons.tsx";
import ExportPage from "@/export/pages/export";
import ExportViewer from "@/export/pages/export-viewer";
import CycleDetailPage from "@/machines/pages/cycle-detail/cycle-detail-page";
import EventDetailPage from "@/machines/pages/event-detail/event-detail-page";

const MACHINES_URL = Object.freeze({
  LOCATION: "/locations",
  LOCATION_DETAIL: "/location/:id",
  MACHINE: "/machine",
  MACHINE_DETAIL: "/machine/:id",
  MACHINE_DETAIL_LIVE: "/machine/live/:id",
  SETTINGS: "/settings",
  POLYGONS: "/polygons",
  EXPORT: "/export",
  EXPORT_VIEWER: "/export/view/:jobId",
  CYCLE_DETAIL: "/machine/cycle/:uuid",
  EVENT_DETAIL: "/machine/event/:uuid",
});

const LOCATION_DETAIL_ROUTE: TRoute = {
  name: "Location",
  path: MACHINES_URL.LOCATION_DETAIL,
  component: LocationDetail,
  roles: [USER_ROLE.DASHBOARD],
};

const MACHINE_ROUTE: TRoute = {
  name: "Machine Detail",
  path: MACHINES_URL.MACHINE_DETAIL,
  component: MachinesDetail,
  roles: [],
};

const MACHINE_LIVE_ROUTE: TRoute = {
  name: "Machine Live",
  path: MACHINES_URL.MACHINE_DETAIL_LIVE,
  component: MachinesLive,
  roles: []
}

const LOCATIONS_ROUTE: TRoute = {
  name: "Locations",
  path: MACHINES_URL.LOCATION,
  component: Locations,
  roles: [],
};

const POLYGONS_ROUTE: TRoute = {
  name: "Polygons",
  path: MACHINES_URL.POLYGONS,
  component: PolygonsPage,
  roles: [],
};

const EXPORT_ROUTE: TRoute = {
  name: "Export",
  path: MACHINES_URL.EXPORT,
  component: ExportPage,
  roles: [],
};

const EXPORT_VIEWER_ROUTE: TRoute = {
  name: "Export Viewer",
  path: MACHINES_URL.EXPORT_VIEWER,
  component: ExportViewer,
  roles: [],
};

const SETTINGS_ROUTE: TRoute = {
  name: "Settings",
  path: MACHINES_URL.SETTINGS,
  component: MachineSettings,
  roles: [],
};

const CYCLE_DETAIL_ROUTE: TRoute = {
  name: "Cycle Detail",
  path: MACHINES_URL.CYCLE_DETAIL,
  component: CycleDetailPage,
  roles: [],
};

const EVENT_DETAIL_ROUTE: TRoute = {
  name: "Event Detail",
  path: MACHINES_URL.EVENT_DETAIL,
  component: EventDetailPage,
  roles: [],
};

const MACHINE_ROUTES = Object.freeze({
  LOCATION_DETAIL_ROUTE,
  LOCATIONS_ROUTE,
  MACHINE_ROUTE,
  MACHINE_LIVE_ROUTE,
  CYCLE_DETAIL_ROUTE,
  EVENT_DETAIL_ROUTE,
  POLYGONS_ROUTE,
  EXPORT_ROUTE,
  EXPORT_VIEWER_ROUTE,
  SETTINGS_ROUTE
});

export { MACHINES_URL, MACHINE_ROUTES };